<template>
	<div class="d-flex flex-column white" style="width: 100%; height: 100%;">
		<div class="d-flex flex-column align-center px-2 mt-2 flex-0" v-if="!step || step == 'select_users'">
			<div class="d-flex align-center mb-0 mx-2" style="width: 100%">
				<v-icon color="#524D4D" @click="searchForStringUser" :disabled="!step">mdi-magnify</v-icon>
				<v-text-field
					v-model="searchUser"
					outlined
					dense
					hide-details
					item-text="name"
					item-value="id"
					return-object
					clearable
					:disabled="!step"
					:label="!step ? 'Buscar':'Buscar Usuario'"
					class="mb-0 mr-2 custom-height-search custom-height-calendar"
					color="#524D4D"
					@input="sendToSearchUser"
				></v-text-field>
			</div>
			<v-progress-linear v-if="loadingUsersChat" indeterminate color="#FF120B"></v-progress-linear>
		</div>
		<div class="d-flex flex-column align-center px-2 mt-2 flex-0" v-if="step == 'select_project'">
			<div class="d-flex align-center mb-0 mx-2" style="width: 100%">
				<v-icon color="#524D4D" @click="searchForStringProject">mdi-magnify</v-icon>
				<v-text-field
					v-model="searchProject"
					outlined
					dense
					hide-details
					item-text="name"
					item-value="id"
					return-object
					clearable
					label="Buscar Proyecto"
					class="mb-0 mr-2 custom-height-search custom-height-calendar"
					color="#524D4D"
					@input="sendToSearchProject"
				></v-text-field>
			</div>
			<v-progress-linear v-if="loadingProjectsChat" indeterminate color="#FF120B"></v-progress-linear>
		</div>
		<div class="px-2 py-4">
			<v-btn
				text
				block
				class="py-2"
				height="auto"
				@click="goBack">
				<div class="d-flex align-center justify-start" style="gap: 10px;width: 100%;">
					<v-avatar color="#FF120B" size="40">
						<v-icon color="white">mdi-arrow-left</v-icon>
					</v-avatar>
					<div>
						<p class="mb-0 text-left font-weight-bold">Volver</p>
					</div>
				</div>
			</v-btn>
			<v-btn
				text
				block
				class="py-2"
				height="auto"
				v-show="!step || step == 'select_users'"
				@click="step = 'select_users'">
				<div class="d-flex align-center justify-start" style="gap: 10px;width: 100%;">
					<v-avatar color="#FF120B" size="40">
						<v-icon color="white">mdi-account-plus</v-icon>
					</v-avatar>
					<div>
						<p class="mb-0 text-left" style="font-size: 10px;">Crear Chat</p>
						<p class="mb-0 text-left font-weight-bold">Con Usuario</p>
					</div>
				</div>
			</v-btn>
			<v-btn
				text
				block
				class="py-2"
				height="auto"
				v-show="!step || step == 'select_project'"
				@click="step = 'select_project'">
				<div class="d-flex align-center justify-start" style="gap: 10px;width: 100%;">
					<v-avatar color="#FF120B" size="40">
						<v-icon color="white">mdi-account-group</v-icon>
					</v-avatar>
					<div>
						<p class="mb-0 text-left" style="font-size: 10px;">Crear Chat Grupal</p>
						<p class="mb-0 text-left font-weight-bold">Del Proyecto</p>
					</div>
				</div>
			</v-btn>
			<div class="d-flex justify-center" v-if="step">
				<v-icon color="#524D4D" size="30">mdi-chevron-down</v-icon>
			</div>
		</div>
		<div v-if="step == 'select_users'">
			<v-list dense class="py-0">
				<v-list-item-group color="#524D4D">
					<v-list-item
						v-for="(user, index) in usersChat"
						:key="index"
						dense
						@click="getOrCreateUserChatRoom(user)"
					>
						<v-list-item-title dense>
							<div class="d-flex align-center">
								<div class="d-flex justify-space-between align-center py-1" style="width: 100%">
									<div class="d-flex align-center" style="width: 100%; gap: 5px; min-width: 0;">
										<div>
											<img :src="user?.profile?.avatar" class="user-avatar" v-if="user?.profile?.avatar"/>
											<v-icon v-else class="user-avatar icon" color="#524D4D">mdi-account</v-icon>
										</div>
										<div style="min-width: 0; flex: 1;">
											<p class="mb-0 truncate-text">{{ user?.profile?.name }} {{ user?.profile?.lastname }} {{ user?.profile?.second_lastname }}</p>
											<p class="mb-0 text-disabled caption truncate-text">{{ user?.email }}</p>
										</div>
										</div>
										<div class="d-flex flex-column align-center" style="gap: 5px;width: 100%;max-width: 125px;">
										<v-btn
											outlined
											x-small
											block
											:color="user?.chat_room ? 'orange' : 'green'"
										>
											<div class="d-flex align-center" v-if="!user?.chat_room" style="gap: 3px;">
												<v-icon small>mdi-message-plus-outline</v-icon>
												<p class="mb-0">Iniciar Chat</p>
											</div>
											<div class="d-flex align-center" v-else style="gap: 3px;">
												<v-icon small>mdi-arrow-right</v-icon>
												<p class="mb-0">Chat existente</p>
											</div>
										</v-btn>
									</div>
								</div>
							</div>
							<v-divider v-if="index < usersChat.length - 1" class="my-2"></v-divider>
						</v-list-item-title>
					</v-list-item>
				</v-list-item-group>
			</v-list>
		</div>

		<div v-else-if="step == 'select_project'">
			<v-list dense class="py-0">
				<v-list-item-group color="#524D4D">
					<v-list-item
						v-for="(project, index) in projectsChat"
						:key="index"
						dense
						@click="getOrCreateProjectChatRoom(project)"
					>
						<v-list-item-title dense>
							<div class="d-flex flex-column">
								<p class="mb-0 truncate-text font-weight-bold">Proyecto: [{{ getProjectLineNumber(project) }}] {{ getProjectName(project) }}</p>
								<div class="d-flex align-center justify-space-between" style="width: 100%">
									<div class="d-flex align-center" style="gap:5px;">
										<div class="mr-2">
											<img :src="getProjectClientAvatar(project)" class="user-avatar" v-if="getProjectClientAvatar(project)"/>
											<v-icon v-else class="user-avatar icon" color="#524D4D">mdi-account</v-icon>
										</div>
										<div>
											<p class="mb-0 text-disabled caption truncate-text">{{ getProjectClientName(project) }}</p>
											<p class="mb-0 text-disabled caption truncate-text">{{ getProjectClientEmail(project) }}</p>
										</div>
									</div>
									<div class="d-flex flex-column align-center" style="gap: 5px;width: 100%;max-width: 132px;">
										<v-btn
											outlined
											x-small
											block
											:color="project?.chat_room ? 'orange' : 'green'"
										>
											<div class="d-flex align-center" v-if="!project?.chat_room" style="gap: 3px;">
												<v-icon small>mdi-message-plus-outline</v-icon>
												<p class="mb-0">Crear Grupo</p>
											</div>
											<div class="d-flex align-center" v-else style="gap: 3px;">
												<v-icon small>mdi-arrow-right</v-icon>
												<p class="mb-0">Grupo existente</p>
											</div>
										</v-btn>
									</div>
								</div>
							</div>
							<v-divider v-if="index < projectsChat.length - 1" class="my-2"></v-divider>
						</v-list-item-title>
					</v-list-item>
				</v-list-item-group>
			</v-list>
		</div>
		
		<div v-else-if="step == 'select_participants'" class="d-flex flex-column" style="height: 100%; width: 100%;">
			<v-list dense class="py-0 flex-grow-1" style="overflow-y: auto;">
				<!-- Header con información del proyecto -->
				<v-list-item dense class="mb-1 sticky px-0" style="background-color: #e9e9e9; min-height: 25px; position: sticky; top: 0;">
					<div class="py-1 px-1 fill-height d-flex align-center justify-center" style="width: 100px;background-color:#FF120B;color: white;">
						<div class="text-center">
							<p class="mb-0 body-2 font-weight-bold">{{ selectedRoomPlNumber }}</p>
							<p class="mb-0" style="font-size: 10px;">Chat Grupal de Proyecto</p>
						</div>
					</div>
					<div class="py-2 px-2" style="width: 100%;">
						<p class="mb-0" style="font-size: 10px;">Añade usuarios al grupo del proyecto:</p>
						<p class="mb-0 caption font-weight-bold">{{ selectedRoomName }}</p>
						<p class="mb-0 text-disabled caption truncate-text">Cliente: {{ selectedRoomUserName }}</p>
					</div>
				</v-list-item>

				<!-- Búsqueda -->
				<v-list-item dense class="mb-2">
					<div class="d-flex flex-column align-center flex-grow-1 mt-2">
						<div class="d-flex align-center mb-0 mx-2 flex-grow-1" style="width: 100%">
							<v-icon color="#524D4D">mdi-magnify</v-icon>
							<v-text-field
								v-model="searchUserForAdd"
								outlined
								dense
								hide-details
								clearable
								label="Buscar Usuario"
								class="mb-0 mr-2 custom-height-search custom-height-calendar"
								color="#524D4D"
								@input="filterUsersForAdd"
							></v-text-field>
						</div>
					</div>
				</v-list-item>

				<!-- Usuarios de Empresa (Expandible) -->
				<v-list-item
						v-if="filteredCompanyUsers.length > 0"
						dense
						style="min-height: 30px; background: #FFF3E0; cursor: pointer;"
						@click="expandCompanyUsers = !expandCompanyUsers"
					>
						<v-list-item-title>
							<div class="d-flex align-center justify-space-between" style="gap: 8px;">
								<div class="d-flex align-center flex-grow-1">
									<v-icon small style="margin-right: 8px; color: #FB8C00;">{{ expandCompanyUsers ? 'mdi-chevron-down' : 'mdi-chevron-right' }}</v-icon>
									<p style="font-size: 12px; font-weight: 600; color: #FB8C00; margin-bottom: 0; flex-grow: 1;">Usuarios de Empresa</p>
								</div>
								<p style="font-size: 10px; font-weight: 600; color: #FB8C00; margin-bottom: 0; text-align: center; padding-right: 8px;max-width: 90px;white-space: wrap;;">
									{{ expandCompanyUsers ? 'Agregar a Chat Grupal' : 'Ver usuarios empresa' }}
								</p>
							</div>
						</v-list-item-title>
					</v-list-item>

				<!-- Lista de Usuarios de Empresa -->
				<template v-if="expandCompanyUsers">
					<v-list-item
						v-for="user in filteredCompanyUsers"
						:key="'company-' + user.id"
						dense
						style="min-height: 42px; border-top: 1px solid #f0f0f0;"
						@click="toggleUserToChatList(user.id)"
					>
						<v-list-item-title dense>
							<div class="d-flex align-center justify-space-between" style="gap: 8px;">
								<div class="d-flex align-center flex-grow-1 py-1" style="min-width: 0;">
									<img
										v-if="getUserAvatar(user)"
										:src="getUserAvatar(user)"
										style="height: 26px; width: 26px; border-radius: 4px; object-fit: contain; margin-right: 8px; flex-shrink: 0;"
									/>
									<v-avatar
										v-else
										:color="getUserTypeColor(user.userType) + '22'"
										size="26"
										class="mr-2"
										style="flex-shrink: 0;"
									>
										<span :style="{ fontSize: '10px', fontWeight: 600, color: getUserTypeColor(user.userType) }">
											{{ getInitials(getFullName(user)) }}
										</span>
									</v-avatar>
									<div class="flex-grow-1" style="min-width: 0;">
										<p class="mb-0 font-weight-bold caption" style="line-height: 1.3;">
											{{ getFullName(user) }}
										</p>
										<p class="mb-0" style="font-size: 10px; color: #999; line-height: 1.3;">
											{{ user.email }}
										</p>
									</div>
								</div>
								<!-- Checkbox para agregar a sala grupal -->
								<div style="width: 80px; display: flex; justify-content: center;">
									<v-icon class="mr-2" small :color="isUserSelected(user.id) ? '#FF120B' : '#524D4D'">
										{{ isUserSelected(user.id) ? 'mdi-checkbox-intermediate' : 'mdi-checkbox-blank-outline' }}
									</v-icon>
								</div>
							</div>
						</v-list-item-title>
					</v-list-item>
				</template>

				<!-- Subcontratistas del Proyecto (Expandible) -->
				<v-list-item
					v-if="filteredSubcontractors.length > 0"
					dense
					style="min-height: 30px; background: #FFF3E0; cursor: pointer;"
					@click="expandSubcontractors = !expandSubcontractors"
				>
					<v-list-item-title>
						<div class="d-flex align-center justify-space-between" style="width: 100%;">
							<div class="d-flex align-center" style="gap: 8px;">
								<v-icon small color="#524D4D">{{ expandSubcontractors ? 'mdi-chevron-down' : 'mdi-chevron-right' }}</v-icon>
								<p class="mb-0 caption font-weight-bold" style="text-transform: uppercase;">Subcontratistas del Proyecto</p>
							</div>
							<v-chip size="small" outlined x-small label class="px-1">{{ filteredSubcontractors.length }}</v-chip>
						</div>
					</v-list-item-title>
				</v-list-item>

				<!-- Lista de Subcontratistas -->
				<template v-if="expandSubcontractors">
					<v-list-item
						v-for="user in filteredSubcontractors"
						:key="'subcontractor-' + user.id"
						dense
						style="min-height: 42px; border-top: 1px solid #f0f0f0;"
						@click="toggleUserToChatList(user.id)"
					>
						<v-list-item-title dense>
							<div class="d-flex align-center">
								<v-icon class="mr-2" small :color="isUserSelected(user.id) ? '#FF120B' : '#524D4D'">
									{{ isUserSelected(user.id) ? 'mdi-checkbox-intermediate' : 'mdi-checkbox-blank-outline' }}
								</v-icon>
								<div class="d-flex justify-space-between align-center" style="width: 100%">
									<div style="flex: 1; min-width: 0;">
										<p class="mb-0 truncate-text">{{ user?.profile?.name }} {{ user?.profile?.lastname }} {{ user?.profile?.second_lastname }}</p>
										<p class="mb-0 text-disabled caption truncate-text">{{ user?.email }}</p>
									</div>
									<div style="margin-left: 8px;">
										<img :src="user?.profile?.avatar" class="user-avatar-small" v-if="user?.profile?.avatar"/>
										<v-icon v-else class="user-avatar-small icon" color="#524D4D">mdi-account</v-icon>
									</div>
								</div>
							</div>
						</v-list-item-title>
					</v-list-item>
				</template>
			</v-list>
			<v-divider class="mt-2"></v-divider>
			<div class="pa-4" style="background: white;">
				<v-btn
					depressed
					color="#FF120B"
					small
					block
					@click="onAddUsersToRoom"
					:dark="true"
				>
					<v-icon left>mdi-message-plus-outline</v-icon>
					<p class="mb-0">Crear Chat Grupal</p>
				</v-btn>
			</div>
		</div>
	</div>
</template>

<script>
import _debounce from 'lodash/debounce'
import {getCompanyUserListToChat, getCompanyProjectLinesToChat, createUserChatRoom, createProjectLineChatRoom} from '@/helpers/api/chats'
import {getProjectCostDetail} from '@/helpers/api/costs'
import { eventBus } from '@/components/Helpers/Events/NotificationsEventBus'

const TYPE_CONFIG = {
	client:        { label: 'Cliente',         color: 'black', groupLabel: 'Cliente' },
	company_user:  { label: 'Profesional Empresa',         color: 'black', groupLabel: 'Profesionales Empresa' },
	project_subcontractor: { label: 'Subcontratista del Proyecto',   color: '#524d4d', groupLabel: 'Subcontratistas del Proyecto' },
	subcontractor: { label: 'Subcontratista',   color: '#524d4d', groupLabel: 'Subcontratistas' }
}
export default {
	name: 'CreateChatRoomEmbedded',
	props: {
		selectChatRoom: {
      type: Function,
      required: true
    }
	},
	computed: {
		isClient(){
			return this.$checkPermissions(['client_capabilities'])
		},
		userInfo(){
			return this.$store.state.user.userInfo
		},
		projectLineMapped(){
			return this.projectsChat
		},
		userListChat(){
			return this.$store.state.users.usersList.filter((user) => this.userInfo.id != user.id)
		},
		companyUserList(){
			return this.$store.state.users.usersList.filter(user => {
				return !user.company_rol?.capabilities?.subcontractor
			})
		},
		filteredCompanyUsers(){
			const companyUsers = this.companyUserList.filter(u => u.id !== this.userInfo.id)
			const q = this.searchUserForAdd.trim().toLowerCase()
			if (!q) return companyUsers
			return companyUsers.filter(user => {
				const fullName = `${user?.profile?.name} ${user?.profile?.lastname} ${user?.profile?.second_lastname}`.toLowerCase()
				const email = user?.email?.toLowerCase()
				return fullName.includes(q) || email.includes(q)
			})
		},
		filteredSubcontractors(){
			const subcontractors = this.subcontractContractorUser.filter(u => u.id !== this.userInfo.id)
			const q = this.searchUserForAdd.trim().toLowerCase()
			if (!q) return subcontractors
			return subcontractors.filter(user => {
				const fullName = `${user?.profile?.name} ${user?.profile?.lastname} ${user?.profile?.second_lastname}`.toLowerCase()
				const email = user?.email?.toLowerCase()
				return fullName.includes(q) || email.includes(q)
			})
		},
		filteredUsersForAdd(){
			if(!this.searchUserForAdd) return this.userListChat
			const search = this.searchUserForAdd.toLowerCase()
			return this.userListChat.filter(user => {
				const fullName = `${user?.profile?.name} ${user?.profile?.lastname} ${user?.profile?.second_lastname}`.toLowerCase()
				const email = user?.email?.toLowerCase()
				return fullName.includes(search) || email.includes(search)
			})
		},
		allowedUsersToCreateRoom(){
			return this.usersChat.filter(user => {
				// Permitir crear sala con usuarios que no tengan una sala existente o que tengan una sala pero esté eliminada
				const existingRoom = this.$store.state.chat.chatRooms.find(room => {
					return room.morphable_type === 'App\\Models\\User' &&
									room.morphable_id === user.id &&
									!room.deleted_at
				})
				return !existingRoom
			})
		},
		selectedRoomPlNumber(){
			if(!this.currentProject){
				return ''
			}
			const project_line_id = this.currentProject.associations?.reduce((acc, item) => {
				return acc || item.project_line_id
			}, null)
			if(!project_line_id){
				return ''
			}
			return 'LP' + project_line_id
		},
		selectedRoomName(){
			if(!this.currentProject){
				return ''
			}
			const project_name = this.currentProject.associations?.reduce((acc, item) => {
				return acc || item.morphable?.name || item.morphable?.info?.project_details
			}, null)
			return project_name || 'Sin nombre asignado'
		},
		selectedRoomUserName(){
			const client = this.currentProject.associations?.reduce((acc, item) => {
				return acc || item.morphable?.client
			}, null)
			if(client){
				const client_name = `${client?.profile?.name} ${client?.profile?.lastname} ${client?.profile?.second_lastname}`
				return client_name
			}
			return ''
		},
		selectedProject(){
			if(!this.currentProject){
				return null
			}
			return this.currentProject?.associations?.find(item => item.morphable_type === 'App\\Models\\Project')
		},
		subcontractContractorUser(){
			let subcontractors = []
			if(this.costTableFromSelectedProject?.subcontracts_info?.cost_table?.contractor && this.costTableFromSelectedProject.subcontracts_info?.cost_table?.subcontract){
				subcontractors.push(this.costTableFromSelectedProject.subcontracts_info.cost_table.contractor)
			}
			if(this.costTableFromSelectedProject?.subcontracts_info?.reception?.contractor && this.costTableFromSelectedProject.subcontracts_info?.reception?.subcontract){
				subcontractors.push(this.costTableFromSelectedProject.subcontracts_info.reception.contractor)
			}
			if(this.costTableFromSelectedProject?.subcontracts_info?.stages?.length){
				subcontractors = subcontractors.concat(this.costTableFromSelectedProject.subcontracts_info.stages.map(s => s.subcontract ? s.contractor : null).filter(c => c))
			}
			if(this.costTableFromSelectedProject?.subcontracts_info?.specialties?.length){
				subcontractors = subcontractors.concat(this.costTableFromSelectedProject.subcontracts_info.specialties.map(s => s.subcontract ? s.contractor : null).filter(c => c))
			}
			
			// Filtrar null y eliminar duplicados por ID
			return subcontractors.filter(contractor => {
				return contractor !== null && contractor !== undefined && contractor.id
			}).reduce((unique, contractor) => {
				// Evitar duplicados basados en ID
				if (!unique.find(c => c.id === contractor.id)) {
					unique.push(contractor)
				}
				return unique
			}, [])
		}
	},
	watch: {
		isClient(newValue) {
			if(newValue){
				this.tab = 1
			}
		},
		selectedProject(newValue){
			if(newValue && newValue.morphable_id){
				this.getProjectCostTable()
			}
			else{
				this.costTableFromSelectedProject = null
			}
		}
	},
	data() {
		return {
			step: null, // 'select_users', 'select_project', 'select_participants'
      optionsUser: {
        page: 1,
        itemsPerPage: 1000,
        sortBy: [],
        sortDesc: [],
      },
			searchUser: '',
      optionsProject: {
        page: 1,
        itemsPerPage: 1000,
        sortBy: [],
        sortDesc: [],
      },
			searchProject: '',
			tab: 0,
			add_chat_users_id: [],
			menuOpen: false,
			loadingUsersChat: true,
			usersChat: [],
			loadingProjectsChat: true,
			projectsChat: [],
			// Modal agregación de usuarios
			addUsersDialogOpen: false,
			currentChatRoom: null,
			currentProject: null,
			currentProjectLineId: null,
			allUsersForAdd: [],
			searchUserForAdd: '',
			loadingUsersForAdd: false,
			expandCompanyUsers: false,
			expandSubcontractors: false,
			costTableFromSelectedProject: null
		};
	},
	mounted() {
		if(this.isClient){
			this.tab = 1
		}
		this.getChatUserList()
		this.getProjectLines()
	},
	methods: {
		goBack(){
			if(this.step){
				this.step = null
				this.currentChatRoom = null
				this.currentProject = null
				this.currentProjectLineId = null
				this.add_chat_users_id = []
				this.searchUserForAdd = ''
				this.expandCompanyUsers = false
				this.expandSubcontractors = false
			}else{
				this.$emit('close')
			}
		},
		getUserTypeLabel(userType) {
			return TYPE_CONFIG[userType]?.label || 'Usuario'
		},
		getUserTypeColor(userType) {
			return TYPE_CONFIG[userType]?.color || '#959595'
		},
		getInitials(name) {
			if (!name) return '?'
			return name.split(' ').map(w => w.charAt(0).toUpperCase()).slice(0, 2).join('')
		},
		getUserAvatar(user) {
			return user?.profile?.avatar || user?.avatar
		},
		getFullName(user) {
			const profile = user?.profile || user
			return [profile?.name, profile?.lastname, profile?.second_lastname]
				.filter(Boolean)
				.join(' ')
		},
		getProjectLineNumber(project){
			return 'LP' + project.number
		},
		getProjectLineProject(project){
			const project_line_id = project.associations?.reduce((acc, item) => {
				return acc || item.project_line_id
			}, null)
			return this.$store.state.projects.projectLines.find(pl => pl.id === project_line_id)
		},
		getProjectName(project){
			const project_name = project.associations?.reduce((acc, item) => {
				return acc || item.morphable?.name || item.morphable?.info?.project_details;
			}, null)
			return project_name || 'Sin nombre asignado'
		},
		getProjectClientName(project){
			const client = project.associations?.reduce((acc, item) => {
				return acc || item.morphable?.client
			}, null)
			if(client){
				const client_name = `${client?.profile?.name} ${client?.profile?.lastname} ${client?.profile?.second_lastname}`
				return client_name
			}
			return ''
		},
		getProjectClientAvatar(project){
			const client = project.associations?.reduce((acc, item) => {
				return acc || item.morphable?.client
			}, null)
			if(client && client.profile?.avatar){
				return client?.profile?.avatar
			}
			return null
		},
		getProjectClientEmail(project){
			const client = project.associations?.reduce((acc, item) => {
				return acc || item.morphable?.client
			}, null)
			if(client){
				const user_email = `${client.email}`
				return user_email
			}
			return ''
		},
		async getProjectCostTable(){
			const cost_table = await getProjectCostDetail({project_id: this.selectedProject.morphable_id})
			if(cost_table.code == 200){
				this.costTableFromSelectedProject = cost_table.cost_table
			}
		},
		async getOrCreateUserChatRoom(user){
			this.menuOpen = false
			// Si ya existe el chat, simplemente seleccionarlo
			if(user?.chat_room){
				this.selectChatRoom(user.chat_room)
				return
			}
			// Si no existe, crear el chat
			const user_chat = await createUserChatRoom({user_id: user.id})
			if(user_chat.code == 200){
				this.currentChatRoom = user_chat.chat_room
				this.selectChatRoom(user_chat.chat_room)
			}
		},
		async getOrCreateProjectChatRoom(project){
			console.log('Proyecto seleccionado para chat grupal:', project)
			this.menuOpen = false
			// Si ya existe el chat, simplemente seleccionarlo
			if(project?.chat_room){
				this.selectChatRoom(project.chat_room)
				return
			}
			const project_line_id = project.associations?.reduce((acc, item) => {
				return acc || item.project_line_id
			}, null)
			if(!project_line_id){
				return null
			}
			// Almacenar el project_line_id para usarlo después
			this.currentProjectLineId = project_line_id
			this.currentProject = project
			this.add_chat_users_id = []
			this.searchUserForAdd = ''
			this.step = 'select_participants'
		},
		sendToSearchUser: _debounce(function() { this.searchForStringUser() }, 800),
		searchForStringUser(){
			this.optionsUser = {...this.optionsUser, ...{page: 1}}
			this.getChatUserList()
		},
		sendToSearchProject: _debounce(function() { this.searchForStringProject() }, 800),
		searchForStringProject(){
			this.optionsProject = {...this.optionsProject, ...{page: 1}}
			this.getProjectLines()
		},
		async getChatUserList(){
			let data = {
				...this.optionsUser,
				start: (this.optionsUser.page - 1) * this.optionsUser.itemsPerPage,
				limit: this.optionsUser.itemsPerPage,
			}
			if(this.searchUser){
				data = {...data, ...{search: this.searchUser}}
			}
			this.loadingUsersChat = true
			const usersChat = await getCompanyUserListToChat(data)
			this.loadingUsersChat = false
			if(usersChat.code == 200){
				this.usersChat = usersChat.users
			}
		},
		async getProjectLines(){
			let data = {
				...this.optionsProject,
				start: (this.optionsProject.page - 1) * this.optionsProject.itemsPerPage,
				limit: this.optionsProject.itemsPerPage,
			}
			if(this.searchProject){
				data = {...data, ...{search: this.searchProject}}
			}
			this.loadingProjectsChat = true
			const projectsChat = await getCompanyProjectLinesToChat(data)
			this.loadingProjectsChat = false
			if(projectsChat.code == 200){
				this.projectsChat = projectsChat.projects
			}
		},
		filterUsersForAdd(){
			// El computed property se encarga del filtrado
		},
		isUserSelected(user_id){
			return this.add_chat_users_id.includes(user_id)
		},
		toggleUserToChatList(user_id){
			if (this.add_chat_users_id.includes(user_id)) {
				this.add_chat_users_id = this.add_chat_users_id.filter(id => id !== user_id)
			} else {
				this.add_chat_users_id = [...this.add_chat_users_id, user_id]
			}
		},
		closeAddUsersDialog(){
			this.addUsersDialogOpen = false
			this.currentChatRoom = null
			this.currentProject = null
			this.add_chat_users_id = []
			this.searchUserForAdd = ''
		},
		async onAddUsersToRoom(){
			if(!this.currentProjectLineId){
				return
			}
			try {
				const data = {
					project_line_id: this.currentProjectLineId,
					users_id: this.add_chat_users_id,
				}
				const project_chat = await createProjectLineChatRoom(data)
				if(project_chat.code == 200){
					const messageData = {
						message: 'Chat grupal creado correctamente',
						title: 'Chat grupal creado',
						type: 'success',
						icon: 'mdi-check-circle',
						color: '#3EBFA3',
					}
					this.setMessage(messageData)
					
					// Cerrar el modal y pasar la sala al componente padre
					this.selectChatRoom(project_chat.chat_room)
					this.currentProjectLineId = null
					this.currentProject = null
					this.add_chat_users_id = []
					this.searchUserForAdd = ''
					this.expandCompanyUsers = false
					this.expandSubcontractors = false
					this.step = null
					eventBus.$emit('reloadChat')
					this.$emit('close')
				}
			} catch (error) {
				const messageData = {
					message: 'Ha ocurrido un error al crear el chat grupal',
					title: 'Error',
					type: 'danger',
					icon: 'mdi-close-octagon',
					color: '#FF1209',
				}
				this.setMessage(messageData)
			}
		},
		setMessage(messageData){
      const data = {
        message: messageData.message,
        title: messageData.title,
        created: new Date(),
        type: messageData.type,
        icon: messageData.icon,
        color: messageData.color,
      }
      this.$store.dispatch('general/addMessage', data)
    }
	}
}
</script>

<style scoped>
	.truncate-text {
		max-width: 230px;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
	.custom-color-tabs .v-tab{
		font-size: 12px;
	}
	.custom-color-tabs .v-tab.v-tab--active {
		background-color: #FF120B;
		color: #FFFFFF;
	}
	.custom-color-tabs .v-tab:not(.v-tab--active) {
		background-color: white;
		color: #000000!important;
	}
	
	.user-avatar{
		width: 40px;
		height: 40px;
		object-fit: cover;
		border-radius: 40px;
	}
	.user-avatar{
		width: 30px;
		height: 30px;
		border-radius: 30px;
	}
	.user-avatar.icon{
		background-color: #F0F2F8;
	}
	
	.user-avatar-small{
		width: 25px;
		height: 25px;
		object-fit: cover;
		border-radius: 25px;
	}
	.user-avatar-small.icon{
		background-color: #F0F2F8;
	}
	
	.custom-height-search {
		height: 35px;
	}
</style>